<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 800 280">
    <defs>
        <style>
            .cls-1 {
                isolation: isolate;
            }

            .cls-2 {
                fill: #27aae1;
            }

            .cls-3 {
                fill: #fff;
            }

            .cls-4 {
                fill: url(#linear-gradient);
            }

            .cls-5 {
                fill: url(#linear-gradient-2);
            }

            .cls-6 {
                fill: url(#linear-gradient-3);
            }

            .cls-7 {
                fill: url(#linear-gradient-4);
            }

            .cls-8 {
                fill: url(#linear-gradient-5);
            }

            .cls-9 {
                fill: url(#linear-gradient-6);
            }

            .cls-10 {
                fill: url(#linear-gradient-7);
            }

            .cls-11 {
                fill: url(#linear-gradient-8);
            }

            .cls-12 {
                fill: url(#linear-gradient-9);
            }

            .cls-13 {
                fill: url(#linear-gradient-10);
            }

            .cls-14 {
                fill: url(#linear-gradient-11);
            }

            .cls-15 {
                fill: url(#linear-gradient-12);
            }

            .cls-16 {
                fill: url(#linear-gradient-13);
            }

            .cls-17 {
                fill: url(#linear-gradient-14);
            }

            .cls-18 {
                fill: url(#linear-gradient-15);
            }

            .cls-19 {
                fill: url(#linear-gradient-16);
            }

            .cls-20 {
                fill: #231f20;
            }

            .cls-21 {
                fill: url(#Fading_Sky);
            }

            .cls-22 {
                fill: #006838;
            }

            .cls-23 {
                fill: #06ff1d;
            }

            .cls-24 {
                mix-blend-mode: screen;
                opacity: 0.75;
            }

            .cls-25 {
                fill: #58595b;
            }

            .cls-26 {
                fill: #e6e7e8;
            }

            .cls-27 {
                font-size: 21.62px;
                font-family: MachineStd, ITC Machine Std;
                letter-spacing: 0.02em;
            }

            .cls-27,
            .cls-31 {
                fill: #ef4136;
            }

            .cls-28 {
                fill: #d1d3d4;
            }

            .cls-29 {
                fill: url(#linear-gradient-17);
            }

            .cls-30 {
                fill: url(#linear-gradient-18);
            }

            .cls-32 {
                fill: #474747;
            }

            .cls-33 {
                fill: #c49a6c;
            }

            .cls-34 {
                fill: #c2b59b;
            }

            .cls-35 {
                fill: #f1f2f2;
            }

            .cls-36 {
                fill: #92278f;
            }

            .cls-37 {
                fill: none;
                stroke: #414042;
                stroke-linecap: round;
                stroke-miterlimit: 10;
                stroke-width: 3px;
            }

            .cls-38 {
                opacity: 0.9;
            }
        </style>
        <linearGradient id="linear-gradient" x1="1029.19" y1="250.19" x2="1029.19" y2="172.31"
            gradientTransform="translate(-68.32 175.64) rotate(-17.73)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" stop-opacity="0" />
            <stop offset="0.3" stop-color="#1dff32" stop-opacity="0.91" />
            <stop offset="1" stop-color="#06ff1d" />
        </linearGradient>
        <linearGradient id="linear-gradient-2" x1="1023.6" y1="191.63" x2="1035.13" y2="191.63"
            gradientTransform="translate(-68.32 175.64) rotate(-17.73)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#858283" />
            <stop offset="1" />
        </linearGradient>
        <linearGradient id="linear-gradient-3" x1="1059.64" y1="186.75" x2="1067.55" y2="186.75"
            xlink:href="#linear-gradient-2" />
        <linearGradient id="linear-gradient-4" x1="992.53" y1="188.07" x2="998.67" y2="188.07"
            xlink:href="#linear-gradient-2" />
        <linearGradient id="linear-gradient-5" x1="986.48" y1="178.61" x2="1072.25" y2="178.61"
            xlink:href="#linear-gradient-2" />
        <linearGradient id="linear-gradient-6" x1="988.14" y1="-144.24" x2="991.97" y2="-144.24"
            gradientTransform="translate(-25.22 162.86)" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#009444" />
            <stop offset="1" stop-color="#006838" />
        </linearGradient>
        <linearGradient id="linear-gradient-7" x1="824.1" y1="-124.63" x2="836.08" y2="-124.63"
            gradientTransform="matrix(-0.54, -0.13, 0.23, -0.97, 1438.02, 5.81)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-8" x1="970.62" y1="-60.31" x2="982.08" y2="-60.31"
            gradientTransform="matrix(0.11, -0.42, 0.77, 0.21, 891.53, 442.08)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-9" x1="820.35" y1="-158.71" x2="831.84" y2="-158.71"
            gradientTransform="matrix(-0.06, -0.21, 0.2, -0.05, 1032.61, 183.36)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-10" x1="809.59" y1="-114.28" x2="821.04" y2="-114.28"
            gradientTransform="matrix(-0.02, -0.22, 0.2, -0.02, 992.97, 192.45)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-11" x1="806.37" y1="-42.98" x2="817.83" y2="-42.98"
            gradientTransform="matrix(0.04, -0.22, 0.2, 0.04, 929.06, 192.21)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-12" x1="828.89" y1="48.1" x2="840.47" y2="48.1"
            gradientTransform="matrix(0.12, -0.18, 0.17, 0.11, 848.07, 163.97)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-13" x1="959.86" y1="23.65" x2="966.69" y2="23.65"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-14" x1="987.4" y1="-103.31" x2="999" y2="-103.31"
            gradientTransform="matrix(0.41, 0.38, -0.67, 0.74, 488.8, -274.61)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-15" x1="1012.87" y1="-175.06" x2="1024.25" y2="-175.06"
            gradientTransform="matrix(-0.3, 0.31, -0.57, -0.55, 1178.37, -390.66)" xlink:href="#linear-gradient-6" />
        <linearGradient id="linear-gradient-16" x1="960" y1="14.93" x2="967.91" y2="14.93"
            gradientTransform="matrix(1, 0, 0, 1, 0, 0)" xlink:href="#linear-gradient-6" />
        <linearGradient id="Fading_Sky" x1="949.14" y1="19.44" x2="978.69" y2="19.44" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#2484c6" />
            <stop offset="1" stop-color="#2484c6" stop-opacity="0" />
        </linearGradient>
        <linearGradient id="linear-gradient-17" x1="99.32" y1="130.16" x2="126.75" y2="130.16"
            gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#fff" />
            <stop offset="1" stop-color="#85d8f7" />
            <stop offset="1" stop-color="#00aeef" />
        </linearGradient>
        <linearGradient id="linear-gradient-18" x1="121.55" y1="130.18" x2="159.69" y2="130.18"
            xlink:href="#linear-gradient-17" />
    </defs>
    <g class="cls-1">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <rect class="cls-2" width="800" height="280" />
                <g id="Clouds">
                    <g id="Cloud5">
                        <path class="cls-3"
                            d="M906.61,249.88A12.15,12.15,0,0,1,894.47,262a12.48,12.48,0,0,1-1.38-.08H828.22a15.11,15.11,0,0,1-1.51.08A14.57,14.57,0,1,1,830,233.25a22.49,22.49,0,0,1,39.88-6.78,18.47,18.47,0,0,1,5.84-.95,18.25,18.25,0,0,1,17.26,12.32,13,13,0,0,1,1.54-.1A12.15,12.15,0,0,1,906.61,249.88Z" />
                    </g>
                    <g id="Cloud4">
                        <path class="cls-3"
                            d="M906.61,198.87A12.15,12.15,0,0,1,894.47,211a12.48,12.48,0,0,1-1.38-.08H828.22a15.11,15.11,0,0,1-1.51.08A14.57,14.57,0,1,1,830,182.23a22.49,22.49,0,0,1,39.88-6.78,18.47,18.47,0,0,1,5.84-.95,18.25,18.25,0,0,1,17.26,12.32,13,13,0,0,1,1.54-.1A12.15,12.15,0,0,1,906.61,198.87Z" />
                    </g>
                    <g id="Cloud3">
                        <path class="cls-3"
                            d="M906.61,147.85A12.15,12.15,0,0,1,894.47,160a12.48,12.48,0,0,1-1.38-.08H828.22a15.11,15.11,0,0,1-1.51.08A14.57,14.57,0,1,1,830,131.21a22.49,22.49,0,0,1,39.88-6.78,18.47,18.47,0,0,1,5.84-1,18.25,18.25,0,0,1,17.26,12.32,13,13,0,0,1,1.54-.1A12.15,12.15,0,0,1,906.61,147.85Z" />
                    </g>
                    <g id="Cloud2">
                        <path class="cls-3"
                            d="M906.61,96.83A12.15,12.15,0,0,1,894.47,109a12.48,12.48,0,0,1-1.38-.08H828.22a15.11,15.11,0,0,1-1.51.08A14.57,14.57,0,1,1,830,80.19a22.48,22.48,0,0,1,39.88-6.77,18.25,18.25,0,0,1,23.1,11.36,13,13,0,0,1,1.54-.09A12.14,12.14,0,0,1,906.61,96.83Z" />
                    </g>
                    <g id="Cloud1">
                        <path class="cls-3"
                            d="M906.61,45.81A12.15,12.15,0,0,1,894.47,58a12.48,12.48,0,0,1-1.38-.08H828.22a15.11,15.11,0,0,1-1.51.08A14.57,14.57,0,1,1,830,29.17a22.49,22.49,0,0,1,39.88-6.77,18.29,18.29,0,0,1,23.1,11.36,13,13,0,0,1,1.54-.09A12.14,12.14,0,0,1,906.61,45.81Z" />
                    </g>
                </g>
                <g id="UFO">
                    <g id="Beam">
                        <polygon class="cls-4"
                            points="997.82 97.38 978.52 103.55 964.45 26.28 964.45 26.28 997.82 97.38" />
                    </g>
                    <g id="Saucer">
                        <circle class="cls-5" cx="970.5" cy="44.63" r="5.76" />
                        <circle class="cls-6" cx="1001.62" cy="29.56" r="3.95" />
                        <circle class="cls-7" cx="937.25" cy="51.53" r="3.07" />
                        <path class="cls-8"
                            d="M1008.14,21.53c-.88,5.53-17.07,14.78-38.15,21.52s-39.62,8.6-43.55,4.61c.69-6.13,15.56-19.51,36.63-26.25S1004,16.94,1008.14,21.53Z" />
                        <g id="Alien">
                            <rect class="cls-9" x="962.92" y="17.81" width="3.83" height="1.61"
                                transform="translate(983.45 -946.22) rotate(90)" />
                            <g id="Arm">
                                <path class="cls-10"
                                    d="M955.5,20.05s5.31-.57,6.58.64c.23.21,0,.17-.09.54-.15.81-6.66-.49-6.66-.49Z" />
                                <path class="cls-11"
                                    d="M956.46,15.8s.36,4-.67,4.9c-.18.16-.14,0-.45-.09-.67-.14.55-5,.55-5Z" />
                                <g id="Hand">
                                    <path class="cls-12"
                                        d="M955.24,13.59a8.89,8.89,0,0,1,.82,2.36c0,.1,0,0-.11,0a12.34,12.34,0,0,1-.86-2.36Z" />
                                    <path class="cls-13"
                                        d="M955.91,13.4a8.53,8.53,0,0,1,.37,2.46c0,.11,0,0-.11,0a11.49,11.49,0,0,1-.41-2.47Z" />
                                    <path class="cls-14"
                                        d="M956.75,13.5A8.65,8.65,0,0,1,956.4,16c0,.09,0,0-.12,0a12.21,12.21,0,0,1,.32-2.48Z" />
                                    <path class="cls-15"
                                        d="M957.72,13.86A9.09,9.09,0,0,1,956.45,16c-.09.06,0,0-.11-.05a12.59,12.59,0,0,1,1.25-2.2Z" />
                                </g>
                            </g>
                            <path class="cls-16"
                                d="M966.69,26.69l-.63.2a50.86,50.86,0,0,1-5.89,1.45,3.08,3.08,0,0,1-.31-1.35,3.57,3.57,0,0,1,0-.46l1.69-5c.27-1.8,1-2.78,2.92-2.52s2.25,1.58,2,3.37Z" />
                            <g id="Arm-2" data-name="Arm">
                                <path class="cls-17"
                                    d="M970.36,24.12s-4.9-1.88-5.4-3.46c-.09-.27.1-.12.35-.41.54-.6,5.55,3.37,5.55,3.37Z" />
                                <path class="cls-18"
                                    d="M967.37,27.25s1.71-3.48,3.07-3.8c.24-.05.11.08.35.27.51.41-3,3.91-3,3.91Z" />
                            </g>
                            <g id="Head">
                                <path class="cls-19"
                                    d="M967.53,14.45a18.39,18.39,0,0,1-4.29,5.19,1.12,1.12,0,0,1-.69.33,12,12,0,0,1-1.28-.16c-.18,0-.28-.23-.36-.39a11.57,11.57,0,0,1-.9-5,6.53,6.53,0,0,1,.55-2.55,3.31,3.31,0,0,1,1.08-1.36,5,5,0,0,1,4.78-.09A2.9,2.9,0,0,1,967.53,14.45Z" />
                                <path class="cls-20"
                                    d="M961.77,14.44c-.2.39-1.34.26-2.11,0a6.71,6.71,0,0,1,.56-2.55C960.93,12.29,962,14,961.77,14.44Z" />
                                <path class="cls-20"
                                    d="M966.94,14.42c0,.57-.73,1-1.63,1s-2.58-.47-2.58-1,2.08-1.85,3-1.85S966.94,13.85,966.94,14.42Z" />
                                <path class="cls-20"
                                    d="M962.9,18a1.86,1.86,0,0,1-1,.18,2,2,0,0,1-.84-.24,4.79,4.79,0,0,0,.87.06,2.54,2.54,0,0,0,1.35-.59A1.84,1.84,0,0,1,962.9,18Z" />
                            </g>
                        </g>
                        <path class="cls-21"
                            d="M978.69,19.3c-.41,2.28-5.82,5.67-13,8.06l-.63.21a49.78,49.78,0,0,1-5.89,1.52c-4.91,1-8.79.87-10-.34.32-2.66-1.94-14.43,9.7-18.68S976.89,17.32,978.69,19.3Z" />
                        <path id="Top_Light_Off" data-name="Top Light Off" class="cls-22"
                            d="M979.06,19.91c.73,2.29-5.36,6.3-13.61,8.93s-15.53,2.92-16.27.62a1.82,1.82,0,0,1,0-.71c1.71,1.66,8.41,1.22,15.91-1.18s13.22-5.93,13.64-8.27A1.55,1.55,0,0,1,979.06,19.91Z" />
                        <g id="Top_Light_On" data-name="Top Light On">
                            <path class="cls-23"
                                d="M979.06,19.91c.73,2.29-5.36,6.3-13.61,8.93s-15.53,2.92-16.27.62a1.82,1.82,0,0,1,0-.71c1.71,1.66,8.41,1.22,15.91-1.18s13.22-5.93,13.64-8.27A1.55,1.55,0,0,1,979.06,19.91Z" />
                        </g>
                        <path id="Main_Light_Off" data-name="Main Light Off" class="cls-22"
                            d="M1008.81,22.64c1.69,5.3-15.35,15.48-38.07,22.74s-42.51,8.87-44.2,3.57a3,3,0,0,1-.1-1.29c3.93,4,22.48,2.13,43.55-4.61s37.27-16,38.15-21.52A3.11,3.11,0,0,1,1008.81,22.64Z" />
                        <g id="Main_Light_On" data-name="Main Light On">
                            <image class="cls-24" width="123" height="72" transform="translate(906.36 1.36)"
                                xlink:href="data:image/png;base64,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" />
                            <path class="cls-23"
                                d="M1008.81,22.64c1.69,5.3-15.35,15.48-38.07,22.74s-42.51,8.87-44.2,3.57a3,3,0,0,1-.1-1.29c3.93,4,22.48,2.13,43.55-4.61s37.27-16,38.15-21.52A3.11,3.11,0,0,1,1008.81,22.64Z" />
                        </g>
                        <g id="Portholes">
                            <circle class="cls-25" cx="968.74" cy="39.14" r="2.86" />
                            <ellipse class="cls-25" cx="986.5" cy="31.93" rx="2.22" ry="2.83"
                                transform="translate(467.47 871.46) rotate(-60.13)" />
                            <ellipse class="cls-25" cx="997.07" cy="26.31" rx="1.46" ry="2.46"
                                transform="translate(578.96 931.86) rotate(-66.73)" />
                            <ellipse class="cls-25" cx="1002.9" cy="20.6" rx="0.72" ry="1.95"
                                transform="translate(769.7 996.23) rotate(-77.73)" />
                            <ellipse class="cls-25" cx="950.1" cy="43.57" rx="2.83" ry="2.22"
                                transform="translate(514.08 888.84) rotate(-65.34)" />
                            <ellipse class="cls-25" cx="938.23" cy="45.12" rx="2.46" ry="1.46"
                                transform="translate(412.78 823.72) rotate(-58.74)" />
                            <ellipse class="cls-25" cx="930.17" cy="43.86" rx="1.95" ry="0.72"
                                transform="translate(272.1 702.71) rotate(-47.73)" />
                        </g>
                    </g>
                </g>
                <g id="Plane_And_Banner" data-name="Plane And Banner">
                    <g id="Plane2">
                        <path class="cls-26"
                            d="M205.76,105.21l-21-.33a14.29,14.29,0,0,0-9.1,3.45l-29.49,29.09c-5.3,5.29-5.44,10.13.31,10.13h39.17c5.56,0,11.81-4.75,13.68-9.94l10.61-28.79C210.66,106.82,208.76,105.25,205.76,105.21Z" />
                        <path id="Tail" class="cls-26"
                            d="M279.13,133.47l33.6.74v-38s-4.48-3.35-19.47.2c-2.31.55-4.87,8.83-6.42,13.13C283.68,118.3,279.13,133.47,279.13,133.47Z" />
                        <path id="Fusilage" class="cls-3"
                            d="M317.73,144.21s-107,16-142.92,19.57c-21.6,2.13-86.64,5.3-86.64,5.3V129.21l229.56,5Z" />
                        <text class="cls-27" transform="translate(218.05 152.11)">SEG</text>
                        <g id="Cockpit">
                            <path id="Canopy" class="cls-28"
                                d="M162.48,131.05s-19.56,11.12-41,11.12c-12.19,0-23.65-6.13-23.65-12.77s17-11.28,23.65-11.28C141.18,118.12,162.48,131.05,162.48,131.05Z" />
                            <g id="Glass">
                                <path class="cls-29"
                                    d="M119.8,119.24c-5.65.35-20.48,4.39-20.48,10.39,0,3.49,8.2,12.54,24.42,11.34a17.84,17.84,0,0,0,3-9.36C126.75,125.78,119.8,119.24,119.8,119.24Z" />
                                <path class="cls-30"
                                    d="M121.55,119.36s6.87,5.59,6.87,12.83c0,4.21-2.86,8.82-2.86,8.82,8.8.1,37.59-9.55,33.79-10.39C159.35,130.62,140.63,119.36,121.55,119.36Z" />
                            </g>
                        </g>
                        <g id="Engine">
                            <rect class="cls-31" x="65.47" y="129.21" width="21.7" height="39.87" />
                            <rect class="cls-3" x="62.47" y="129.21" width="16.98" height="39.87" />
                            <ellipse class="cls-31" cx="87.23" cy="149.14" rx="4.85" ry="20" />
                            <ellipse class="cls-3" cx="79.45" cy="149.14" rx="4.85" ry="20" />
                            <ellipse class="cls-3" cx="62.47" cy="149.14" rx="4.82" ry="19.87" />
                            <ellipse class="cls-32" cx="62.47" cy="148.86" rx="3.57" ry="14.53" />
                        </g>
                        <g id="Propellar">
                            <ellipse class="cls-33" cx="56.65" cy="126.8" rx="3.29" ry="21.92" />
                            <path class="cls-3"
                                d="M62.47,149c0,4.46-1.36,8.07-5.82,8.07S41.17,153.45,41.17,149,52.2,141,56.65,141,62.47,144.56,62.47,149Z" />
                            <ellipse class="cls-34" cx="56.65" cy="170.93" rx="3.29" ry="21.92" />
                        </g>
                        <path class="cls-26"
                            d="M243.43,207.4H211.28c-4.65,0-11.55-2.64-15.51-6l-47.43-40.33c-6.91-5.87-7.5-11-.9-11h45.7c6.6,0,16.16,5.1,21,11L247,201.39C249.72,204.76,248.07,207.4,243.43,207.4Z" />
                        <ellipse class="cls-26" cx="317.73" cy="139.21" rx="1.23" ry="5" />
                    </g>
                    <path id="Banner" class="cls-35"
                        d="M784.75,164.69s-39.07-1.33-85.11-1c-27.56.19-55.55,2.15-84.94,2-39.83-.16-62.73-2.15-85.1-2-18.56.09-84.94,1-84.94,1V110.34s47.4-1.25,84.94-1c37,.25,64,2,85.1,2,18.63,0,51.54-1.79,84.94-2,42.81-.28,85.11,1,85.11,1Z" />
                    <rect class="cls-35" x="444.66" y="111.55" width="340.09" height="51.57" />
                    <path class="cls-36"
                        d="M477.67,131.3l-2.05-.05V145.9l-3.64-.1V131.15l-2.05-.06v-3.4c3.1.09,4.64.14,7.74.21Z" />
                    <path class="cls-36"
                        d="M488.79,146.2l-3.64-.08V138.8l-1.52,0v7.32L480,146V128l3.63.08v7.33l1.52,0v-7.33l3.64.07Z" />
                    <path class="cls-36"
                        d="M500.54,146.38l-3.56,0c-.13-1.33-.19-2-.31-3.33l-2.12,0-.3,3.32-3.55-.06c.89-7.2,1.33-10.81,2.22-18l5.27.08Zm-4.82-14.29h-.35l-.55,7.5,1.58,0C496.13,136.6,496,135.09,495.72,132.09Z" />
                    <path class="cls-36"
                        d="M511.27,146.49l-3,0c-.94-3.53-1.41-5.29-2.36-8.81h0v8.78l-3.41,0V128.35l3,0c.93,3.48,1.4,5.22,2.33,8.71h0v-8.69l3.42,0Z" />
                    <path class="cls-36"
                        d="M518,136.19h0c1-3.07,1.43-4.61,2.38-7.69l3.72,0L521,136.94c1.45,3.85,2.18,5.78,3.64,9.63l-3.95,0c-1.05-3.08-1.58-4.63-2.64-7.71h0v7.7l-3.64,0V128.47l3.64,0Z" />
                    <path class="cls-36" d="M539.92,139v7.55h-3.64V139l-3.13-10.5h3.64l1.3,6.51h0l1.3-6.52h3.64Z" />
                    <path class="cls-36"
                        d="M553.44,143.9l-2.34,2.63-4.05,0-2.4-2.61V131.12l2.4-2.62,3.9,0,2.49,2.6Zm-5.16-12v11.25h1.52V131.88Z" />
                    <path class="cls-36"
                        d="M565.35,143.81,563,146.45l-4.07,0-2.42-2.6V128.44l3.63,0v14.65h1.59V128.4l3.63,0Z" />
                    <path class="cls-36" d="M582.9,131.59l-3.41,0V135l2.77,0v3.4l-2.77,0v7.85l-3.64,0v-18l7-.08Z" />
                    <path class="cls-36"
                        d="M594,143.48l-2.33,2.65-4,.05-2.4-2.59V130.78l2.4-2.65,3.89,0c1,1,1.5,1.55,2.49,2.59Zm-5.15-12v11.26l1.52,0V131.49Z" />
                    <path class="cls-36"
                        d="M605.82,135.24,604,137c.74.69,1.1,1,1.83,1.74v7.2l-3.52.05v-7.2l-1.52,0V146l-3.64.05V128l6.24-.09,2.44,2.58Zm-5-3.89v4.06l1.52,0v-4.06Z" />
                    <path class="cls-36"
                        d="M622.18,138.15v7.55l-3.63.05V138.2l-3.13-10.45,3.64-.06c.51,2.6.77,3.9,1.29,6.51h0l1.3-6.53,3.63-.06Z" />
                    <path class="cls-36"
                        d="M635.7,142.89l-2.33,2.65-4,.06-2.4-2.59V130.2l2.4-2.65,3.89-.06,2.49,2.58Zm-5.15-12v11.25l1.52,0V130.91Z" />
                    <path class="cls-36"
                        d="M647.62,142.73l-2.36,2.65-4.07.05-2.43-2.58V127.41l3.64,0V142l1.58,0V127.34l3.64,0Z" />
                    <path class="cls-36"
                        d="M659.46,134.5l-1.82,1.76,1.82,1.74v7.2l-3.52,0V138l-1.52,0v7.2l-3.63.05V127.25l6.23-.07c1,1,1.47,1.55,2.44,2.59Zm-5-3.89v4l1.52,0v-4Z" />
                    <path class="cls-36" d="M677.06,130.38l-3.42,0v3.4l2.78,0v3.4l-2.78,0v7.86l-3.63,0V127l7-.06Z" />
                    <path class="cls-36"
                        d="M686,130.32l-3.07,0v3.39h2.58v3.4h-2.58v4.46l3.15,0V145l-6.78,0V127l6.7,0Z" />
                    <path class="cls-36"
                        d="M695.22,130.28h-3.06v3.4h2.58v3.39h-2.58v4.46h3.15v3.4l-6.78,0V126.9l6.69,0Z" />
                    <path class="cls-36"
                        d="M706.67,142.3l-2.35,2.61h-6.43v-18h6.3l2.48,2.62Zm-5.15-12v11.26H703V130.26Z" />
                    <path class="cls-36"
                        d="M716.45,135.7l2,1.79v4.84l-2.4,2.6h-6.37V126.86l6.37,0,2.07,2.28v4.76Zm-3.1-5.43v3.83h1.49v-3.82Zm0,7.23v4h1.49v-4Z" />
                    <path class="cls-36"
                        d="M729.93,145l-3.57,0c-.12-1.33-.19-2-.31-3.33l-2.11,0c-.13,1.33-.19,2-.31,3.33l-3.55,0c.89-7.21,1.34-10.82,2.23-18l5.26,0C728.51,134.18,729,137.8,729.93,145Zm-4.83-14.27h-.35l-.55,7.5h1.59C725.51,135.27,725.38,133.76,725.1,130.76Z" />
                    <path class="cls-36"
                        d="M740.45,134l-3.54-.05v-3.53l-1.57,0v11.26l1.57,0V137.4l3.54,0v5.09l-2.4,2.58-3.74-.05-2.6-2.64V129.61l2.38-2.59,4,0,2.4,2.65Z" />
                    <path class="cls-36"
                        d="M747,134.91h0l2.38-7.66,3.72.07-3.15,8.38c1.46,3.87,2.18,5.81,3.64,9.69l-3.94-.08L747,137.56h0v7.71l-3.64-.06v-18l3.64.06Z" />
                    <path class="cls-36"
                        d="M768,133.18c-.43,3-.65,4.46-1.08,7.43l-1.5-.05-1-7.48v-5.49l3.63.1Zm0,12.57-3.63-.11v-3.47l3.63.1Z" />
                    <line class="cls-37" x1="446.02" y1="113.98" x2="318.96" y2="139.21" />
                    <line class="cls-37" x1="445.26" y1="161.22" x2="318.96" y2="139.21" />
                </g>
                <g id="Cloud_Zero" data-name="Cloud Zero" class="cls-38">
                    <path class="cls-3"
                        d="M1436.53,210.64a64,64,0,0,1-63.92,63.82,67.85,67.85,0,0,1-7.27-.42h-341.6a77.65,77.65,0,0,1-8,.42,76.73,76.73,0,0,1-.64-153.45,79.24,79.24,0,0,1,18,2.06,118.44,118.44,0,0,1,210-35.7,96.26,96.26,0,0,1,121.75,59.87,70.76,70.76,0,0,1,8.1-.53A64,64,0,0,1,1436.53,210.64Z" />
                </g>
            </g>
        </g>
    </g>
</svg>